/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-nested-ternary */
const prod = process.env.NODE_ENV === "production";
const devLive = process.env.React_App_DEV_LIVE || "live";
const devStaging = process.env.React_App_DEV_LIVE === "staging" || false;
console.log("devStaging", devLive);

// Public guest website (storefront /r /c) — NOT the admin host.
const publicWebsiteUrl =
  devLive === "live"
    ? "https://www.letsgoplan.com"
    : devLive === "staging"
      ? "https://staging.letsgoplan.com"
      : "http://localhost:3000";

// const serverUrl = devLive
//   ? "https://api.letsgoplan.com/"
//   : devStaging
//   ? "https://staging-api.letsgoplan.com/"
//   : "http://192.168.1.81:9000/";

//"http://192.168.1.57:5000/";

const baseUrl =
  devLive === "live"
    ? "https://api.letsgoplan.com/"
    : devLive === "staging"
      ? "https://staging-api.letsgoplan.com/"
      : "http://192.168.0.137:3000/";

const socketUrl =
  devLive === "live"
    ? "https://chat.letsgoplan.com/"
    : devLive === "staging"
      ? "https://staging-chat.letsgoplan.com/"
      : "http://192.168.1.81:3001";

const webSite =
  devLive === "live"
    ? "https://admin.letsgoplan.com/"
    : devLive === "staging"
      ? "https://staging-admin.letsgoplan.com/"
      : "http://localhost:3000";

console.log("webSite", webSite);

export default {
  siteName: "React",
  siteIcon: "ion-flash",
  footerText: `© ${new Date().getFullYear()} test`,
  apiUrl: baseUrl,
  bffUrl: "https://bookingsletsgoplan.com/",
  socketUrl: socketUrl,
  csvUrl: prod ? `SampleCsv` : "http://192.168.1.62:9000/SampleCsv",
  domainUrl: webSite,
  /** Guest site origin for creator /r and /c links (staging vs www). */
  publicWebsiteUrl,
  sailsUrl: "http://localhost:33969/",

  // Maps JavaScript SDK key for browser widgets (destination autocomplete,
  // chat map bubbles). The old literal here was the leaked/revoked mobile
  // key, so these widgets are dead until REACT_APP_GOOGLE_BROWSER_KEY is
  // baked into the build. Create it as a browser key restricted by HTTP
  // referrer to *.letsgoplan.com with only Maps JavaScript API + Places
  // API enabled, plus a daily quota cap. Server-style Places/Translate
  // calls must NOT use this — they go through the API's /v1/gproxy.
  googleAutoCompleteKey:
    process.env.REACT_APP_GOOGLE_BROWSER_KEY ||
    "AIzaSyA-bDjvT_FZDlmzBOhXotMaSqQ6VcHrGEk",
  // Shared app-secret gate for the API's Google proxy (same header the
  // mobile app sends). The proxy strips/replaces any key and enforces
  // per-IP rate limits, so no spendable credential ships in this bundle.
  gproxyAppSecret: "n41WLco_jw9_sqt3-aWrwU_3NPKWCHBZNPxhjxdbu18",
  GIPHYApiKey: "lnMVUf8H6KqoRUlBJRhAdZIQBHvSi1oc",
  urlRegex: /(https?:\/\/[^\s'"\\]+|www\.[^\s'"\\]+)/g,

  itineraryAi: {
    shuffle: "https://staging-ai.letsgoplan.com/itinenary/shuffle/",
    travelTime:
      "https://staging-ai.letsgoplan.com/itinenary/travel-time-calculation/",
    timeValidation:
      "https://staging-ai.letsgoplan.com/itinenary/time-validation/",
  },

  endpoints: {
    login: "user/login",
    logout: "admin/user/logout",
    blogAnalyticsOverview: "admin/blog-analytics/overview",
    blogAnalyticsPostDetail: "admin/blog-analytics/post-detail",
    blogCommentsList: "admin/blog-comments/list",
    blogCommentsModerate: "admin/blog-comments/moderate",
    blogCommentsReply: "admin/blog-comments/reply",
    blogCommentsReplies: "admin/blog-comments/replies",
    adminConfigurationList: "admin/admin-configuration/list",
    adminConfigurationDelete: "admin/admin-configuration/delete",
    adminConfigurationUpdate: "admin/admin-configuration/update",
    adminConfigurationCreate: "admin/admin-configuration/create",
    itineraryList: "admin/itinerary/list",
    itineraryAssistUserTrips: "admin/itinerary-assist/user-trips",
    itineraryAssistTripDetail: "admin/itinerary-assist/trip-detail",
    itineraryAssistCreateTrip: "admin/itinerary-assist/create-trip",
    itineraryAssistUpdateTrip: "admin/itinerary-assist/update-trip",
    itineraryAssistGenerate: "admin/itinerary-assist/generate",
    itineraryAssistUpdate: "admin/itinerary-assist/update",
    itineraryAssistSuggestions: "admin/itinerary-assist/suggestions",
    apiLogList: "admin/api-log/list",
    apiLogListDelete: "admin/api-log/delete",
    errorLogList: "admin/error-log/list",
    errorLogListDelete: "admin/error-log/delete",
    cmsList: "admin/cms/list",
    cmsListDelete: "admin/cms/delete",
    cmsListUpdate: "admin/cms/update",
    cmsListCreate: "admin/cms/create",
    emailTemplateList: "admin/email-template/list/",
    emailTemplateListDelete: "admin/email-template/delete",
    emailTemplateListStatusUpdate: "admin/email-template/status-change",
    emailTemplateListUpdate: "admin/email-template/update",
    emailTemplateListCreate: "admin/email-template/create",
    faqCategoryCreate: "admin/faq-category/create",
    faqCategoryUpdate: "admin/faq-category/update",
    faqCategoryList: "admin/faq-category/list",
    faqCategoryDelate: "admin/faq-category/delete",
    faqCategoryStatusChange: "admin/faq-category/status-change",
    faqList: "admin/faq/list",
    faqListDelete: "admin/faq/delete",
    faqListUpdate: "admin/faq/update",
    faqListCreate: "admin/faq/create",
    travelPreferencesList: "admin/travel-preferences/list",
    travelPreferencesListDelete: "admin/travel-preferences/delete",
    travelPreferencesListStatusChange: "admin/travel-preferences/status-change",
    travelPreferencesListUpdate: "admin/travel-preferences/update",
    travelPreferencesListCreate: "admin/travel-preferences/create",
    introScreenListUpdatePosition: "admin/intro-screen/update-position",
    introScreenList: "admin/intro-screen/list",
    introScreenVideoRemove: "v1/common/remove-image",
    introScreenListUpdate: "admin/intro-screen/update",
    tripCategoryList: "admin/trip-category/list",
    tripCategoryListDelete: "admin/trip-category/delete",
    tripCategoryListStatusChange: "admin/trip-category/status-change",
    tripCategoryListUpdate: "admin/trip-category/update",
    tripCategoryListCreate: "admin/trip-category/create",
    soloTrips: "admin/trips/get-solo-trips",
    EventManagement: "admin/event/get-public-private-event-list",
    EventManagementDetail: "admin/event/get-event-details",
    EventManagementDeletedList: "admin/event/get-deleted-events",
    convertEventPubPrivate: "admin/event/convert-public-to-private",
    GroupTrip: "admin/trips/get-group-trips",
    updateSocialTravelTrip: "admin/trips/update-social-travel",
    SponsoredTrip: "admin/trips/get-pending-sponsored-trips",
    TripDetails: "v1/trip/get-trip",
    convertPublicPrivate: "admin/trips/convert-public-to-private",
    SponsoredTripRequest: "admin/trips/accept-or-reject-sponsore-trip",
    usersList: "admin/user/get-user-list",
    usersVendorList: "admin/vendor/all-vendor-list",
    usersDetail: "admin/user/get-user-detail",
    userCheckBox: "admin/user/enable-influencer-program",
    toggleAdvisor: "admin/user/toggle-advisor",
    advisorList: "admin/user/advisor-list",
    advisorScheduleGet: "admin/user/advisor-schedule/get",
    advisorScheduleSet: "admin/user/advisor-schedule/set",
    advisorScheduleSlotCreate: "admin/user/advisor-schedule/slot/create",
    advisorScheduleSlotUpdate: "admin/user/advisor-schedule/slot/update",
    advisorScheduleSlotDelete: "admin/user/advisor-schedule/slot/delete",
    advisorScheduleTimezone: "admin/user/advisor-schedule/timezone",
    advisorCallHistory: "admin/user/advisor-call-history",
    bulkUserAction: "admin/user/bulk-action",
    customerCommerceSummary: "admin/user/customer-commerce-summary",
    customerCommerceTimeline: "admin/user/customer-commerce-timeline",
    customerCommerceOrderDetail: "admin/user/customer-commerce-order-detail",
    customerCommerceHealth: "admin/user/customer-commerce-health",

    // Bookings Console
    bookingsFlightsList: "admin/bookings/flights",
    bookingsFlightsDetail: "admin/bookings/flights/detail",
    bookingsHotelsList: "admin/bookings/hotels",
    bookingsHotelsDetail: "admin/bookings/hotels/detail",
    bookingsEsimList: "admin/bookings/esim",
    bookingsEsimDetail: "admin/bookings/esim/detail",
    bookingsInsuranceList: "admin/bookings/insurance",
    bookingsInsuranceDetail: "admin/bookings/insurance/detail",
    bookingsInsuranceSync: "admin/bookings/insurance/sync",
    bookingsInsuranceRetry: "admin/bookings/insurance/retry",
    bookingsInsuranceResend: "admin/bookings/insurance/resend",
    bookingsInsuranceRefreshDocs: "admin/bookings/insurance/refresh-docs",
    bookingsPackagesList: "admin/bookings/packages",
    bookingsPackagesDetail: "admin/bookings/packages/detail",
    bookingsBundlesList: "admin/bookings/bundles",
    bookingsBundlesDetail: "admin/bookings/bundles/detail",
    bookingsSearch: "admin/bookings/search",

    // Promo Theme Campaigns
    promoCampaignsList: "admin/promo-campaigns/list",
    promoCampaignsGet: "admin/promo-campaigns",
    promoCampaignsCreate: "admin/promo-campaigns/create",
    promoCampaignsUpdate: "admin/promo-campaigns/update",
    promoCampaignsDelete: "admin/promo-campaigns/delete",
    promoCampaignsStatus: "admin/promo-campaigns/update-status",
    promoCampaignActivePreview: "v1/promo-campaigns/active",

    notificationsList: "admin/notification/list",

    serviceRequestList: "admin/service/all-service-request-list",
    serviceRequestDetailLogs: "admin/service/service-request-quotes",

    serviceList: "admin/service/list",
    serviceCreate: "admin/service/create",
    serviceUpdate: "admin/service/update",
    serviceDelate: "admin/service/delete",
    serviceStatusChange: "admin/service/update-service-status",
    cuisineList: "admin/cuisine/list",
    cuisineCreate: "admin/cuisine/create",
    cuisineUpdate: "admin/cuisine/update",
    cuisineDelate: "admin/cuisine/delete",
    includeList: "admin/include/list",
    includeCreate: "admin/include/create",
    includeUpdate: "admin/include/update",
    includeDelate: "admin/include/delete",
    includeStatus: "admin/include/update-include-status",
    ourPickSave: "admin/our-picks/get-our-picks-data",
    ourPickList: "admin/our-picks/our-picks-list",
    ourPickCreate: "admin/our-picks/save-our-picks-data",
    ourPickLogList: "admin/our-picks/our-picks-log-list",
    ourPickDelete: "admin/our-picks/delete-our-pick",
    vendorList: "admin/vendor/list",
    vendorApproveRejectList: "admin/vendor/approve-reject-vendor",
    updatePopularVendor: "admin/vendor/update-popular",
    franchisesList: "admin/franchises/franchise-list",
    franchisesCreate: "admin/franchises/create-franchise",
    franchisesUpdate: "admin/franchises/update-franchise",
    franchisesDelate: "admin/franchises/delete-franchise",
    raiseIssueReasonList: "admin/issue-reasons/issue-reason-list",
    raiseIssueReasonCreate: "admin/issue-reasons/create-issue-reason",
    raiseIssueReasonUpdate: "admin/issue-reasons/update-issue-reason",
    raiseIssueReasonDelate: "admin/issue-reasons/delete-issue-reason",
    raiseIssueReasonStatus: "admin/issue-reasons/issue-reason-status-change",
    chatReportList: "admin/admin-chat/get-report-chat-list",
    chatConvertationList: "admin/admin-chat/get-conversations",
    chatUserBlock: "admin/user/block-unblock-user",
    raiseIssueList: "admin/issue-reasons/issues-list",
    paymentRefundPayout: "v1/payment/refund-payout-amount",
    raiseIssueStatus: "admin/issue-reasons/issue-status-change",
    purchaseTokenList: "admin/purchase-token/purchase-token-list",
    purchaseTokenCreate: "admin/purchase-token/create-purchase-token",
    purchaseTokenUpdate: "admin/purchase-token/update-purchase-token",
    purchaseTokenDelate: "admin/purchase-token/delete-purchase-token",
    purchaseTokenStatusChange:
      "admin/purchase-token/purchase-token-status-change",
    itinerarySettingsList: "admin/itinerary-settings/itinerary-settings-list",
    itinerarySettingsUpdate:
      "admin/itinerary-settings/update-itinerary-setting",
    userUsedTokens: "admin/user/get-user-used-tokens",
    userTokensCreditDebit: "admin/token/add-subtract-tokens",
    activeDelativeUser: "admin/user/activate-deactivate-user",
    activeDativeVendor: "admin/vendor/activate-deactivate-vendor",
    csvExportApi: "admin/admin/export-data",
    activelanguageList: "v1/language/get-active-languages",

    userSubscriptionPlan: "admin/subscription-plan/get-user-plan",
    subscriptionPlanCreate: "admin/subscription-plan/create",
    subscriptionPlanUpdate: "admin/subscription-plan/update",
    subscriptionPlanList: "admin/subscription-plan/list",
    subscriptionPlanDelate: "admin/subscription-plan/delete",
    subscriptionPlanStatusChange:
      "admin/subscription-plan/update-active-status",

    ratingList: "admin/lets-go-ratings/get-ratings-list",
    ratingDelete: "admin/lets-go-ratings/delete-rating",
    ratingStatusChange: "admin/lets-go-ratings/change-rating-status",

    addSurpriseCities: "admin/surprise-me-cities/add",
    surpriseCities: "admin/surprise-me-cities/list",
    surpriseCitiesDelete: "admin/surprise-me-cities/delete",
    surpriseMeItinerary: "admin/surprise-me/list",

    dashboardCharts: "admin/analytics/admin-analytics",
    dashboardChartTwo: "admin/analytics/admin-analytics-data",

    popularDestinationList:
      "admin/popular-destination/popular-destination-list",
    popularDestinationCreateUpdate:
      "admin/popular-destination/add-update-popular-destination",
    popularDestinationDelete:
      "admin/popular-destination/delete-popular-destination",

    commonData: "v1/common/get-common-data",

    ChatBotSuggestionCreate: "admin/ai-chatbot-suggestion/create",
    ChatBotSuggestionDelete: "admin/ai-chatbot-suggestion/delete",
    ChatBotSuggestionList: "admin/ai-chatbot-suggestion/list",
    ChatBotSuggestionUpdate: "admin/ai-chatbot-suggestion/update",
    ChatBotSuggestionStatusChange: "admin/ai-chatbot-suggestion/status-change",

    PopularDestinationLogs:
      "admin/popular-destination/popular-destination-log-list",

    deletedUserList: "admin/user/get-deleted-user-list",
    deletedVendorList: "admin/vendor/deleted-vendor-list",

    stripeConnectBalance: "admin/analytics/fetch-stripe-connected-balance",

    // withdrawal-config
    minMaxwithdrawalList: "admin/min_max_withdrawal/list",
    minMaxwithdrawalListDelete: "admin/min_max_withdrawal/delete",
    currencyList: "admin/currency/list",
    minMaxwithdrawalListAdd: "admin/min_max_withdrawal/create",
    minMaxwithdrawalListUpdate: "admin/min_max_withdrawal/update",
    searchMembers: "admin/user/get-all-active-users",

    // referral details
    referralList: "admin/user/get-referral-users-list",

    // Accessibility crud
    listAccessibility: 'admin/accessibility/list',
    createAccessibility: 'admin/accessibility/create',
    updateAccessibility: 'admin/accessibility/update',
    deleteAccessibility: 'admin/accessibility/delete',

    // Coupon management 
    couponList: "admin/coupon/list",
    couponCreate: "admin/coupon/create",
    couponUpdate: "admin/coupon/update",
    couponDelete: "admin/coupon/delete",
    couponStatusChange: "admin/coupon/update-status",
    couponClaimHistory: 'admin/coupon/history-list',
    hotelCouponList: "api/hotel-open/coupons/admin/list",
    hotelCouponCreate: "api/hotel-open/coupons/admin/create",
    hotelCouponUpdate: "api/hotel-open/coupons/admin/update",
    hotelCouponDelete: "api/hotel-open/coupons/admin/delete",
    hotelCouponToggleStatus: "api/hotel-open/coupons/admin/toggle-status",
    hotelCouponHistory: "api/hotel-open/coupons/admin/history",
    cashbackSettingsDetail: "admin/cashback-settings/details",
    cashbackSettingsUpdate: "admin/cashback-settings/update",
    hearAboutUsSettingsDetail: "admin/hear-about-us-settings/details",
    hearAboutUsSettingsUpdate: "admin/hear-about-us-settings/update",
    hearAboutUsOptions: "v1/common/hear-about-us",
    cashbackAdminGrant: "api/cashback/admin/grant",
    cashbackAdminVoid: "api/cashback/admin/void",
    cashbackAdminDebit: "api/cashback/admin/debit",
    cashbackAdminLots: "api/cashback/admin/lots",
    cashbackAdminExpireDue: "api/cashback/admin/expire-due",
    flightProviderSettings: "api/admin/flight-providers/settings",
    flightProviderAnalytics: "api/admin/flight-providers/analytics",
    creatorList: "api/creators/admin",
    creatorCreate: "api/creators/admin",
    creatorUpdate: "api/creators/admin",
    creatorDetail: "api/creators/admin",
    creatorLinkUpdate: "api/creators/admin/links",
    creatorLinkMedia: "api/creators/admin/links",
    creatorMedia: "api/creators/admin/media",
    creatorCommissions: "api/creators/admin/commissions",
    creatorCommissionVoid: "api/creators/admin/commissions",
    creatorChallenges: "api/creators/admin/challenges",
    creatorChallengePosts: "api/creators/admin/challenges",
    creatorChallengePostsInbox: "api/creators/admin/challenge-posts",
    creatorChallengePostDelete: "api/creators/admin/challenge-posts",
    creatorAssetPacks: "api/creators/admin/asset-packs",
    creatorChallengeAssets: "api/creators/admin/challenge-assets",
    creatorAssetCompliance: "api/creators/admin/asset-compliance",
    creatorContentBankPacks: "api/creators/admin/content-bank/packs",
    creatorByUsers: "api/creators/admin/by-users",
    hotelAutocomplete: "api/hotels/autocomplete",
    regionAutocomplete: "api/regions/autocomplete",
    creatorToggleForUser: "api/creators/admin/toggle-for-user",
    agencyList: "api/creators/admin/agencies",
    agencyCreate: "api/creators/admin/agencies",
    agencyUpdate: "api/creators/admin/agencies",
    agencyDetail: "api/creators/admin/agencies",
    agencyCreators: "api/creators/admin/agencies",
    agencyUsers: "api/creators/admin/agencies",
    agencyPayouts: "api/creators/admin/agencies",
  },
  google: {
    analyticsKey: "UA-xxxxxxxxx-1",
  },
  tinyEditorKey: "tdph45ujaqoy7h2ctckgtzryt9pm1srlgvh8jskrcc46wtf6", //  Added by pavan patil with email :- pavan.patil@groovyweb.co
  dashboard: "/dashboard",
};
